export const HelpText = ({children}: {children: string}) => {
  return (
    <p className={"text-sm text-slate-400 font-light"}>
      {children}
    </p>
  )
}